export default "__VITE_ASSET__CdvbzTt0__"